// src/components/NavBar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => {
  const tabs = [
    { to: '/feed', label: 'MY FEED' },           // ← new, first in order
    { to: '/rank-me', label: 'RANK SOMETHING' },
    // { to: '/my-rankings', label: 'MY RANKINGS' }, // ← removed (merged into Profile)
    { to: '/create-list', label: 'CREATE A LIST' },
    { to: '/friends', label: 'FRIENDS' },
    { to: '/my-profile', label: 'MY PROFILE', mobileOnly: true },
  ];

  return (
    <div className="section-header">
      <div className="nav-wrap">
        <nav className="nav-tabs" aria-label="Main navigation">
          {tabs.map(t => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `nav-item${isActive ? ' active' : ''} ${t.mobileOnly ? ' mobile-only' : ''}`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default NavBar;
